import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal, Kicker } from "../components/Reveal";
import { SOLUTIONS, IMAGES } from "../data/site";

const Solutions = () => (
    <div data-testid="solutions-page">
        <PageHero
            kicker="SOLUTIONS"
            title="Solutions Built Around"
            accent="Your Process"
            sub="Thermal, electrical and automation engineering — combined into dependable process heating systems."
            image={IMAGES.hero}
            crumb="Solutions"
        />
        <section className="bg-white py-20 md:py-24">
            <div className="mx-auto max-w-[1440px] space-y-6 px-4 sm:px-6 lg:px-10">
                {SOLUTIONS.map((s, i) => (
                    <Reveal key={s.title} delay={0.05}>
                        <div className={`group grid overflow-hidden border border-slate-200 lg:grid-cols-2 ${i % 2 ? "" : ""}`} data-testid={`solution-${s.title.toLowerCase().replace(/\s+/g, "-")}`}>
                            <div className={`relative min-h-[280px] overflow-hidden ${i % 2 ? "lg:order-2" : ""}`}>
                                <img src={s.image} alt={`${s.title} — industrial engineering`} loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                                <span className="absolute left-0 top-0 bg-brand-red px-4 py-2 font-mono text-[10px] tracking-[0.22em] text-white">
                                    0{i + 1}
                                </span>
                            </div>
                            <div className="flex flex-col justify-center bg-brand-mist p-8 md:p-12 technical-grid-light">
                                <Kicker>{s.title.split(" ")[0].toUpperCase()} ENGINEERING</Kicker>
                                <h2 className="mt-3 font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight text-brand-charcoal">{s.title}</h2>
                                <p className="mt-4 text-sm leading-relaxed text-slate-500">{s.desc}</p>
                                <ul className="mt-6 grid gap-2.5 sm:grid-cols-2">
                                    {s.items.map((item) => (
                                        <li key={item} className="flex items-center gap-2.5 text-sm text-slate-600">
                                            <span className="h-1.5 w-1.5 rotate-45 bg-brand-red" /> {item}
                                        </li>
                                    ))}
                                </ul>
                                <Link to="/get-a-quote" data-testid={`solution-quote-${i}`}
                                    className="group/link mt-8 inline-flex w-max items-center gap-2 font-display text-xs font-bold tracking-[0.16em] text-brand-red">
                                    DISCUSS THIS SOLUTION <ArrowUpRight size={14} className="transition-transform group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
                                </Link>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
        <section className="bg-brand-ink py-16 grain relative technical-grid">
            <div className="relative mx-auto flex max-w-[1440px] flex-wrap items-center justify-between gap-6 px-4 sm:px-6 lg:px-10">
                <p className="font-display text-2xl font-extrabold uppercase tracking-tight text-white">
                    Furnace + Panel + Automation. <span className="text-brand-ember">One System.</span>
                </p>
                <Link to="/get-a-quote" data-testid="solutions-cta-quote"
                    className="group flex items-center gap-3 bg-brand-red px-7 py-4 font-display text-sm font-bold tracking-[0.14em] text-white transition-colors hover:bg-brand-ember">
                    REQUEST A QUOTE <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                </Link>
            </div>
        </section>
    </div>
);

export default Solutions;
